import { render, staticRenderFns } from "./MetadadosExtensaoForm.vue?vue&type=template&id=f6158d42"
import script from "./MetadadosExtensaoForm.vue?vue&type=script&lang=js"
export * from "./MetadadosExtensaoForm.vue?vue&type=script&lang=js"
import style0 from "./MetadadosExtensaoForm.vue?vue&type=style&index=0&id=f6158d42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports